module.exports = __webpack_public_path__ + "img/roll-874.1ada3379.png";